import riderConfirmCode from './modules/rider-confirm-code'
import confirmationEntrega from './modules/confirmation-entrega'
import * as itemForBR from './modules/item-for-br'
import advertise from '@/utils/track/modules/advertise.js'

export default {
  ...riderConfirmCode,
  ...confirmationEntrega,
  ...itemForBR,
  ...advertise,
}
